<svg width="129" height="130" viewBox="0 0 129 130" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="35.9714" y="66.4854" width="79.075" height="47.445" rx="5" fill="url(#paint0_linear_3812_5602)"/>
<path d="M0 34.0427H90.1282V89.9402C90.1282 92.7016 87.8896 94.9402 85.1282 94.9402H5C2.23858 94.9402 0 92.7016 0 89.9402V34.0427Z" fill="url(#paint1_linear_3812_5602)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 9C0 6.23858 2.23858 4 5 4H85.1282C87.8896 4 90.1282 6.23858 90.1282 9V34.0427H0V9ZM30.0427 21.1111C30.0427 23.8017 27.8615 25.9829 25.1709 25.9829C22.4802 25.9829 20.2991 23.8017 20.2991 21.1111C20.2991 18.4205 22.4802 16.2393 25.1709 16.2393C27.8615 16.2393 30.0427 18.4205 30.0427 21.1111ZM65.7693 25.9829C68.4599 25.9829 70.6411 23.8017 70.6411 21.1111C70.6411 18.4205 68.4599 16.2393 65.7693 16.2393C63.0786 16.2393 60.8975 18.4205 60.8975 21.1111C60.8975 23.8017 63.0786 25.9829 65.7693 25.9829Z" fill="url(#paint2_linear_3812_5602)"/>
<rect x="15.4275" y="41.3503" width="11.5385" height="11.5385" rx="3" fill="url(#paint3_linear_3812_5602)"/>
<rect x="31.5813" y="41.3503" width="11.5385" height="11.5385" rx="3" fill="url(#paint4_linear_3812_5602)"/>
<rect x="47.7354" y="41.3503" width="11.5385" height="11.5385" rx="3" fill="url(#paint5_linear_3812_5602)"/>
<rect x="63.8892" y="41.3503" width="11.5385" height="11.5385" rx="3" fill="url(#paint6_linear_3812_5602)"/>
<rect x="15.4275" y="57.5043" width="11.5385" height="11.5385" rx="3" fill="url(#paint7_linear_3812_5602)"/>
<rect x="47.7354" y="57.5042" width="11.5385" height="11.5385" rx="5.76923" fill="url(#paint8_linear_3812_5602)"/>
<rect x="31.5813" y="57.5043" width="11.5385" height="11.5385" rx="3" fill="url(#paint9_linear_3812_5602)"/>
<rect x="63.8892" y="57.5043" width="11.5385" height="11.5385" rx="3" fill="url(#paint10_linear_3812_5602)"/>
<rect x="15.4275" y="73.6582" width="11.5385" height="11.5385" rx="3" fill="url(#paint11_linear_3812_5602)"/>
<rect x="47.7354" y="73.6581" width="11.5385" height="11.5385" rx="3" fill="url(#paint12_linear_3812_5602)"/>
<rect x="31.5813" y="73.6582" width="11.5385" height="11.5385" rx="3" fill="url(#paint13_linear_3812_5602)"/>
<rect x="63.8892" y="73.6582" width="11.5385" height="11.5385" rx="3" fill="url(#paint14_linear_3812_5602)"/>
<g filter="url(#filter0_i_3812_5602)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.1709 29.2308C29.6553 29.2308 33.2906 25.5955 33.2906 21.1111C33.2906 16.6267 29.6553 12.9915 25.1709 12.9915C20.6866 12.9915 17.0513 16.6267 17.0513 21.1111C17.0513 25.5955 20.6866 29.2308 25.1709 29.2308ZM25.1709 25.9829C27.8615 25.9829 30.0427 23.8017 30.0427 21.1111C30.0427 18.4205 27.8615 16.2393 25.1709 16.2393C22.4802 16.2393 20.2991 18.4205 20.2991 21.1111C20.2991 23.8017 22.4802 25.9829 25.1709 25.9829Z" fill="url(#paint15_linear_3812_5602)"/>
</g>
<g filter="url(#filter1_i_3812_5602)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M65.7693 29.2308C70.2537 29.2308 73.889 25.5955 73.889 21.1111C73.889 16.6267 70.2537 12.9915 65.7693 12.9915C61.285 12.9915 57.6497 16.6267 57.6497 21.1111C57.6497 25.5955 61.285 29.2308 65.7693 29.2308ZM65.7693 25.9829C68.4599 25.9829 70.6411 23.8017 70.6411 21.1111C70.6411 18.4205 68.4599 16.2393 65.7693 16.2393C63.0786 16.2393 60.8975 18.4205 60.8975 21.1111C60.8975 23.8017 63.0786 25.9829 65.7693 25.9829Z" fill="url(#paint16_linear_3812_5602)"/>
</g>
<g filter="url(#filter2_i_3812_5602)">
<rect x="22.7351" width="4.87179" height="18.6752" rx="2.4359" fill="url(#paint17_linear_3812_5602)"/>
</g>
<g filter="url(#filter3_i_3812_5602)">
<rect x="63.3333" width="4.87179" height="18.6752" rx="2.4359" fill="url(#paint18_linear_3812_5602)"/>
</g>
<g filter="url(#filter4_d_3812_5602)">
<rect x="31.9114" y="75.3953" width="79.075" height="47.445" rx="5" transform="rotate(-11.6334 31.9114 75.3953)" fill="url(#paint19_linear_3812_5602)"/>
</g>
<rect x="39.9385" y="84.5071" width="13.5557" height="10.5433" rx="1" transform="rotate(-11.6334 39.9385 84.5071)" fill="url(#paint20_linear_3812_5602)"/>
<path d="M40.5461 87.4576L44.6031 86.6224C44.8068 86.5805 45.0059 86.7116 45.0478 86.9153C45.0898 87.119 44.9586 87.3181 44.7549 87.36L40.698 88.1953L40.5461 87.4576Z" fill="url(#paint21_linear_3812_5602)"/>
<path d="M41.3054 91.1455L45.3624 90.3103C45.566 90.2683 45.7652 90.3995 45.8071 90.6032C45.849 90.8068 45.7179 91.006 45.5142 91.0479L41.4573 91.8831L41.3054 91.1455Z" fill="url(#paint22_linear_3812_5602)"/>
<path d="M54.7344 89.1498L50.6774 89.985C50.4737 90.027 50.2746 89.8958 50.2327 89.6921C50.1908 89.4884 50.3219 89.2893 50.5256 89.2474L54.5825 88.4122L54.7344 89.1498Z" fill="url(#paint23_linear_3812_5602)"/>
<path d="M53.9751 85.4615L49.9182 86.2968C49.7145 86.3387 49.5154 86.2076 49.4734 86.0039C49.4315 85.8002 49.5626 85.6011 49.7663 85.5592L53.8232 84.7239L53.9751 85.4615Z" fill="url(#paint24_linear_3812_5602)"/>
<path d="M47.9438 89.7788C47.7401 89.8207 47.541 89.6896 47.499 89.4859L47.0434 87.273C47.0015 87.0694 47.1326 86.8702 47.3363 86.8283C47.54 86.7864 47.7391 86.9175 47.7811 87.1212L48.2366 89.3341C48.2786 89.5378 48.1475 89.7369 47.9438 89.7788Z" fill="url(#paint25_linear_3812_5602)"/>
<rect x="44.5207" y="85.6119" width="5.02476" height="6.53095" rx="1.5" transform="rotate(-11.6334 44.5207 85.6119)" stroke="url(#paint26_linear_3812_5602)"/>
<g filter="url(#filter5_i_3812_5602)">
<path d="M105.787 95.0743C105.999 94.2781 107.029 94.066 107.539 94.7136L112.591 101.134C113.051 101.718 112.735 102.582 112.007 102.732L104.85 104.205C104.122 104.355 103.49 103.686 103.682 102.968L105.787 95.0743Z" fill="url(#paint27_linear_3812_5602)"/>
</g>
<g filter="url(#filter6_i_3812_5602)">
<path d="M102.457 103.64C102.245 104.437 101.214 104.649 100.705 104.001L95.6527 97.5808C95.1931 96.9966 95.5089 96.1328 96.237 95.9829L103.394 94.5094C104.122 94.3595 104.754 95.0283 104.562 95.7465L102.457 103.64Z" fill="url(#paint28_linear_3812_5602)"/>
</g>
<g filter="url(#filter7_i_3812_5602)">
<path d="M92.6622 97.7767C92.8745 96.9804 93.9047 96.7683 94.4143 97.4159L99.4664 103.836C99.9261 104.421 99.6103 105.284 98.8822 105.434L91.725 106.908C90.9969 107.058 90.3656 106.389 90.5571 105.671L92.6622 97.7767Z" fill="url(#paint29_linear_3812_5602)"/>
</g>
<g filter="url(#filter8_i_3812_5602)">
<rect x="95.9316" y="87.5879" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 95.9316 87.5879)" fill="url(#paint30_linear_3812_5602)"/>
</g>
<g filter="url(#filter9_i_3812_5602)">
<rect x="99.6196" y="86.8285" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 99.6196 86.8285)" fill="url(#paint31_linear_3812_5602)"/>
</g>
<g filter="url(#filter10_i_3812_5602)">
<rect x="103.308" y="86.0692" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 103.308 86.0692)" fill="url(#paint32_linear_3812_5602)"/>
</g>
<g filter="url(#filter11_i_3812_5602)">
<rect x="106.996" y="85.3099" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 106.996 85.3099)" fill="url(#paint33_linear_3812_5602)"/>
</g>
<g filter="url(#filter12_i_3812_5602)">
<rect x="78.2297" y="91.2327" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 78.2297 91.2327)" fill="url(#paint34_linear_3812_5602)"/>
</g>
<g filter="url(#filter13_i_3812_5602)">
<rect x="81.918" y="90.4734" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 81.918 90.4734)" fill="url(#paint35_linear_3812_5602)"/>
</g>
<g filter="url(#filter14_i_3812_5602)">
<rect x="85.6057" y="89.7141" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 85.6057 89.7141)" fill="url(#paint36_linear_3812_5602)"/>
</g>
<g filter="url(#filter15_i_3812_5602)">
<rect x="89.2939" y="88.9548" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 89.2939 88.9548)" fill="url(#paint37_linear_3812_5602)"/>
</g>
<g filter="url(#filter16_i_3812_5602)">
<rect x="60.5263" y="94.8774" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 60.5263 94.8774)" fill="url(#paint38_linear_3812_5602)"/>
</g>
<g filter="url(#filter17_i_3812_5602)">
<rect x="64.2145" y="94.118" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 64.2145 94.118)" fill="url(#paint39_linear_3812_5602)"/>
</g>
<g filter="url(#filter18_i_3812_5602)">
<rect x="67.9025" y="93.3588" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 67.9025 93.3588)" fill="url(#paint40_linear_3812_5602)"/>
</g>
<g filter="url(#filter19_i_3812_5602)">
<rect x="71.5908" y="92.5995" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 71.5908 92.5995)" fill="url(#paint41_linear_3812_5602)"/>
</g>
<g filter="url(#filter20_i_3812_5602)">
<rect x="42.8237" y="98.522" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 42.8237 98.522)" fill="url(#paint42_linear_3812_5602)"/>
</g>
<g filter="url(#filter21_i_3812_5602)">
<rect x="46.5117" y="97.7627" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 46.5117 97.7627)" fill="url(#paint43_linear_3812_5602)"/>
</g>
<g filter="url(#filter22_i_3812_5602)">
<rect x="50.1996" y="97.0034" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 50.1996 97.0034)" fill="url(#paint44_linear_3812_5602)"/>
</g>
<g filter="url(#filter23_i_3812_5602)">
<rect x="53.8879" y="96.2441" width="2.25929" height="5.27167" rx="1.12964" transform="rotate(-11.6334 53.8879 96.2441)" fill="url(#paint45_linear_3812_5602)"/>
</g>
<g filter="url(#filter24_i_3812_5602)">
<rect x="45.1018" y="109.586" width="28.6176" height="1.50619" rx="0.753095" transform="rotate(-11.6334 45.1018 109.586)" fill="url(#paint46_linear_3812_5602)"/>
</g>
<g filter="url(#filter25_i_3812_5602)">
<rect x="45.709" y="112.537" width="28.6176" height="1.50619" rx="0.753095" transform="rotate(-11.6334 45.709 112.537)" fill="url(#paint47_linear_3812_5602)"/>
</g>
<g opacity="0.4">
<path d="M77.1456 114.523L94.4081 62.5286L104.465 60.4581C107.17 59.9012 109.814 61.6424 110.37 64.3471L117.921 101.023C118.478 103.728 116.737 106.372 114.032 106.928L77.1456 114.523Z" fill="url(#paint48_linear_3812_5602)" fill-opacity="0.4" style="mix-blend-mode:screen"/>
</g>
<g opacity="0.4">
<path d="M109.711 62.6993C110.019 63.1911 110.247 63.7453 110.371 64.3472L117.921 101.023C118.478 103.728 116.737 106.372 114.032 106.928L93.6323 111.128L109.711 62.6993Z" fill="url(#paint49_linear_3812_5602)" fill-opacity="0.4" style="mix-blend-mode:screen"/>
</g>
<defs>
<filter id="filter0_i_3812_5602" x="17.0513" y="11.9915" width="17.2393" height="17.2393" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter1_i_3812_5602" x="57.6497" y="11.9915" width="17.2393" height="17.2393" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter2_i_3812_5602" x="22.7351" y="-1" width="5.87177" height="19.6752" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter3_i_3812_5602" x="63.3333" y="-1" width="5.87177" height="19.6752" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter4_d_3812_5602" x="26.8159" y="58.3544" width="93.2088" height="68.6067" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-2" dy="2"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_3812_5602"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3812_5602" result="shape"/>
</filter>
<filter id="filter5_i_3812_5602" x="103.647" y="93.3314" width="10.1589" height="10.8951" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter6_i_3812_5602" x="95.4377" y="93.4882" width="10.1589" height="10.8951" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter7_i_3812_5602" x="90.5225" y="96.0338" width="10.1589" height="10.8951" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter8_i_3812_5602" x="96.1359" y="86.3367" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter9_i_3812_5602" x="99.8239" y="85.5773" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter10_i_3812_5602" x="103.512" y="84.818" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter11_i_3812_5602" x="107.2" y="84.0587" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter12_i_3812_5602" x="78.4341" y="89.9814" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter13_i_3812_5602" x="82.1223" y="89.2222" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter14_i_3812_5602" x="85.8101" y="88.4629" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter15_i_3812_5602" x="89.4983" y="87.7036" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter16_i_3812_5602" x="60.7307" y="93.6262" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter17_i_3812_5602" x="64.4189" y="92.8668" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter18_i_3812_5602" x="68.1069" y="92.1075" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter19_i_3812_5602" x="71.7951" y="91.3483" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter20_i_3812_5602" x="43.028" y="97.2708" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter21_i_3812_5602" x="46.716" y="96.5115" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter22_i_3812_5602" x="50.404" y="95.7522" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter23_i_3812_5602" x="54.0922" y="94.9929" width="3.86719" height="6.21021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter24_i_3812_5602" x="45.238" y="102.952" width="29.061" height="7.97351" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<filter id="filter25_i_3812_5602" x="45.8452" y="105.902" width="29.061" height="7.97351" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5602"/>
</filter>
<linearGradient id="paint0_linear_3812_5602" x1="35.9714" y1="113.93" x2="121.327" y2="95.3748" gradientUnits="userSpaceOnUse">
<stop stop-color="#0B2B65"/>
<stop offset="1" stop-color="#2366B0"/>
</linearGradient>
<linearGradient id="paint1_linear_3812_5602" x1="2.49635e-08" y1="94.9402" x2="99.1582" y2="70.124" gradientUnits="userSpaceOnUse">
<stop stop-color="#D5D9E0"/>
<stop offset="1" stop-color="#F8F8FA"/>
</linearGradient>
<linearGradient id="paint2_linear_3812_5602" x1="2.32445e-07" y1="34.0427" x2="88.3552" y2="-0.531034" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint3_linear_3812_5602" x1="15.4275" y1="52.8888" x2="28.2528" y2="51.2159" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint4_linear_3812_5602" x1="31.5813" y1="52.8888" x2="44.4066" y2="51.2159" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint5_linear_3812_5602" x1="47.7354" y1="52.8888" x2="60.5606" y2="51.2159" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint6_linear_3812_5602" x1="63.8892" y1="52.8888" x2="76.7144" y2="51.2159" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint7_linear_3812_5602" x1="15.4275" y1="69.0427" x2="28.2528" y2="67.3699" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint8_linear_3812_5602" x1="47.7354" y1="69.0426" x2="60.85" y2="66.8249" gradientUnits="userSpaceOnUse">
<stop stop-color="#41682A"/>
<stop offset="1" stop-color="#9DC747"/>
</linearGradient>
<linearGradient id="paint9_linear_3812_5602" x1="31.5813" y1="69.0427" x2="44.4066" y2="67.3699" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint10_linear_3812_5602" x1="63.8892" y1="69.0427" x2="76.7144" y2="67.3699" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint11_linear_3812_5602" x1="15.4275" y1="85.1967" x2="28.2528" y2="83.5238" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint12_linear_3812_5602" x1="47.7354" y1="85.1965" x2="60.5606" y2="83.5237" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint13_linear_3812_5602" x1="31.5813" y1="85.1967" x2="44.4066" y2="83.5238" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint14_linear_3812_5602" x1="63.8892" y1="85.1967" x2="76.7144" y2="83.5238" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint15_linear_3812_5602" x1="17.0513" y1="29.2308" x2="35.5089" y2="26.1096" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint16_linear_3812_5602" x1="57.6497" y1="29.2308" x2="76.1073" y2="26.1096" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint17_linear_3812_5602" x1="22.7351" y1="18.6752" x2="28.4197" y2="18.4244" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint18_linear_3812_5602" x1="63.3333" y1="18.6752" x2="69.0178" y2="18.4244" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint19_linear_3812_5602" x1="31.9114" y1="122.84" x2="117.267" y2="104.285" gradientUnits="userSpaceOnUse">
<stop stop-color="#2A095C"/>
<stop offset="1" stop-color="#281887"/>
</linearGradient>
<linearGradient id="paint20_linear_3812_5602" x1="39.9385" y1="95.0504" x2="54.8432" y2="92.5509" gradientUnits="userSpaceOnUse">
<stop stop-color="#D97D0E"/>
<stop offset="1" stop-color="#FFE352"/>
</linearGradient>
<linearGradient id="paint21_linear_3812_5602" x1="40.698" y1="88.1953" x2="42.715" y2="85.0836" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint22_linear_3812_5602" x1="41.4573" y1="91.8831" x2="43.4743" y2="88.7714" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint23_linear_3812_5602" x1="54.5825" y1="88.4122" x2="52.5655" y2="91.5239" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint24_linear_3812_5602" x1="53.8232" y1="84.7239" x2="51.8062" y2="87.8356" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint25_linear_3812_5602" x1="48.3126" y1="89.7029" x2="46.2245" y2="87.6658" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint26_linear_3812_5602" x1="43.9302" y1="92.754" x2="50.8471" y2="91.8182" gradientUnits="userSpaceOnUse">
<stop stop-color="#30333A"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint27_linear_3812_5602" x1="103.265" y1="104.532" x2="114.435" y2="100.671" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B86CB"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint28_linear_3812_5602" x1="104.979" y1="94.1831" x2="93.6502" y2="98.5844" gradientUnits="userSpaceOnUse">
<stop stop-color="#41682A"/>
<stop offset="1" stop-color="#9DC747"/>
</linearGradient>
<linearGradient id="paint29_linear_3812_5602" x1="90.1402" y1="107.234" x2="101.31" y2="103.374" gradientUnits="userSpaceOnUse">
<stop stop-color="#C65533"/>
<stop offset="1" stop-color="#FDB814"/>
</linearGradient>
<linearGradient id="paint30_linear_3812_5602" x1="95.9316" y1="92.8596" x2="98.5591" y2="92.6691" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint31_linear_3812_5602" x1="99.6196" y1="92.1002" x2="102.247" y2="91.9097" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint32_linear_3812_5602" x1="103.308" y1="91.3409" x2="105.935" y2="91.1505" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint33_linear_3812_5602" x1="106.996" y1="90.5816" x2="109.624" y2="90.3912" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint34_linear_3812_5602" x1="78.2297" y1="96.5043" x2="80.8573" y2="96.3139" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint35_linear_3812_5602" x1="81.918" y1="95.7451" x2="84.5455" y2="95.5546" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint36_linear_3812_5602" x1="85.6057" y1="94.9858" x2="88.2332" y2="94.7954" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint37_linear_3812_5602" x1="89.2939" y1="94.2265" x2="91.9215" y2="94.0361" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint38_linear_3812_5602" x1="60.5263" y1="100.149" x2="63.1538" y2="99.9587" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint39_linear_3812_5602" x1="64.2145" y1="99.3897" x2="66.8421" y2="99.1993" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint40_linear_3812_5602" x1="67.9025" y1="98.6304" x2="70.5301" y2="98.44" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint41_linear_3812_5602" x1="71.5908" y1="97.8712" x2="74.2183" y2="97.6807" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint42_linear_3812_5602" x1="42.8237" y1="103.794" x2="45.4512" y2="103.603" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint43_linear_3812_5602" x1="46.5117" y1="103.034" x2="49.1392" y2="102.844" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint44_linear_3812_5602" x1="50.1996" y1="102.275" x2="52.8272" y2="102.085" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint45_linear_3812_5602" x1="53.8879" y1="101.516" x2="56.5154" y2="101.325" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint46_linear_3812_5602" x1="45.1018" y1="111.092" x2="48.0566" y2="101.599" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint47_linear_3812_5602" x1="45.709" y1="114.043" x2="48.6638" y2="104.549" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint48_linear_3812_5602" x1="97.5852" y1="60.3544" x2="97.5852" y2="114.523" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint49_linear_3812_5602" x1="105.829" y1="62.6993" x2="105.829" y2="111.128" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
